module.exports = __webpack_public_path__ + "img/3.26c50713.png";